import { render, staticRenderFns } from "./MoveRadioButton.vue?vue&type=template&id=3fec70a6&scoped=true&"
import script from "./MoveRadioButton.vue?vue&type=script&lang=js&"
export * from "./MoveRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./MoveRadioButton.vue?vue&type=style&index=0&id=3fec70a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fec70a6",
  null
  
)

export default component.exports